exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".title {\n  font-weight: bold;\n  font-size: 14px;\n  padding-bottom: 24px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vc/manage/datacenter/datacenter-details-vc.scss
// module id = i+pD
// module chunks = 0